import { module } from 'modujs';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css/bundle'

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
          click: {
            dots: 'toggleDots',
          }
        }
    }

    init() {
      var items = 1;
      var pagination = false;
      var navigation = false;
      var breakpoints = [];
      var autoplay = false;
      var slideChange = false;
      
      if (this.getData('items')) {
        items = this.getData('items');
      }

      if (this.getData('pagination')) {
        pagination = {
          el: this.getData('pagination'),
          clickable: true,
          bulletActiveClass: 'round-active',
          bulletClass: 'round',
        };
      }

      if (this.getData('navigation')) {
        navigation = {
          nextEl: this.getData('navigation') + '-next',
          prevEl: this.getData('navigation') + '-prev',
        };
      }

      if (this.getData('breakpoints')) {
        breakpoints = JSON.parse(this.getData('breakpoints'));
      }

      if (this.getData('autoplay')) {
        autoplay = {
          delay: Number(this.getData('autoplay')),
          disableOnInteraction: false,
        };
      }

      // $(".slideIndex").text(items);

      if(this.getData('counter')) {
        let counter = this.getData('counter');
        slideChange = function(swiper) {
          $(counter).text(parseInt(swiper.realIndex) + parseInt(items));
        };
      }

      new Swiper(this.el, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: parseInt(items),
        slidesPerGroup: parseInt(items),
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        autoHeight: false,

        // If we need pagination
        pagination: pagination,

        // Navigation arrows
        navigation: navigation,

        breakpoints: breakpoints,

        autoplay : autoplay,

        on: {
          // realIndexChange: (swiper) => $(".slideIndex").text(parseInt(swiper.realIndex) + parseInt(items))
          realIndexChange: slideChange,
        } 
      });
    }

    toggleDots(e){
      let dot = parseInt(e.currentTarget.id.split('dots-')[1]) * 100;
      let images = document.getElementsByClassName('b-accueil_img');

      for(let i = 0; i < images.length; i++){
        images[i].style.transform = `translateX(-${dot}%)`;  
      }
    }
}
